import { AxiosResponse } from 'axios'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { RequestREAD } from 'services/Instances'

export function ReportsBlockServices() {
  const path = 'RelatorioBloqueio'

  const getFillCards = async (request: RequestGet): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/FillCards', request)

  const getRelatorioFinal = async (
    request: RequestGetReport
  ): Promise<AxiosResponse<ReponseReportFinal>> =>
    await RequestREAD.post(path + '/RelatorioFinal', request, {
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  const getRelatorioExcel = async (
    request: RequestGetReport
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/RelatorioFinalExcel', request, {
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  const getPDFResult = async (
    idUsuario: number,
    request: RequestGetPDFReport
  ): Promise<AxiosResponse<string>> =>
    await RequestREAD.post(path + '/RelatorioFinalPDF', request, {
      params: {
        idUsuario: idUsuario
      },
      timeout: 99999999999,
      timeoutErrorMessage: 'Tempo de consulta excedido.'
    })

  return { getFillCards, getRelatorioExcel, getRelatorioFinal, getPDFResult }
}

export interface RequestGet {
  tipo: number
  periodoBloqueioInicio: string
  periodoBloqueioFim: string
  nomeFornecedor: string
  fornecedorIds: number[]
  cdContrato: string
  contratoIds: number[]
  empresaSubContratadaIds: number[]
  nomeEmpresa: string
  empresaIds: number[]
  cdCentroPlanta: string
  centroPlantaIds: number[]
  analistaId: number
  nomeSubcontratada: string
  unidadeGestoraId: IOnChangeUnidadeGestora
  tipoSolicitacao: number
  motivoBloqueioId: number
  cdFolhaRegistroSRV: string
  txDocumento: string
  txReferencia: string
  checkedAll?: boolean
}

export interface RequestReturn {
  contratoId: number
  cdContrato: string
  fornecedorId: number
  nmFornecedor: string
  empresaId: number
  nmEmpresa: string
  centroPlantaId: number
  nmCentroPlanta: string
  subFornecedorId: number
  nmSubFornecedor: string
}

interface ICard {
  id: number
  name: string
  flChecked: boolean
}

export interface IFillCardsResponse {
  contratos: ICard[]
  fornecedores: ICard[]
  empresas: ICard[]
  centroPlantas: ICard[]
  subFornecedores?: ICard[]
  subcontratadas?: ICard[]
}

export interface RequestGetReport {
  dataIni?: Date
  dataFim?: Date
  tipo?: number
  fornecedorIds?: number[]
  contratoIds?: number[]
  empresaSubContratadaIds?: number[]
  empresaIds?: number[]
  centroPlantaIds?: number[]
  tipoSolicitacao?: number
  usuarioAnalistaId?: number
  cdFolhaRegistroSRV?: string
  txDocumento?: string
  txReferencia?: string
  checkedAll?: boolean
}

export interface RequestGetPDFReport extends RequestGetReport {
  pageNumber: number
  pageSize: number
}

export interface ReponseReportFinal {
  entity: {
    dtEmissao: string
    groups: any
    tipoSolicitacao: string
    txTitle: string
    mensagem?: string
    currentPage: number
    totalItensPaginated: number
    totalRisco: number
    totalRiscoSemFR: number
    totalGeralRisco: number
    totalGeralRiscoDifNGT: number
    totalRiscoNGT: number
    motivos: IMotivosResponse[]
  }
  mensagem: string
  sucesso: boolean
}

export interface IMotivosResponse {
  motivoBloqueio: string
  totalRisco: number
}

export interface IResponseResultGroups {
  content: {
    cdContratoPend: string
    nmContraparte: string
    nmFornecedor: string
    nmSolicitanteBloqueio: string
    de: string | null
    dir: string | null
    gg: string | null
    ger: string | null
    dtBloqueio: Date | string
    dtLiberacao: Date | string
    observacao: string
    motivoBloqueio: string
    totalFRs: number
    vlRisco: number
    vlRiscoTotal: number
    vlRiscoTotalGeral: number
    vlRiscoTotalSemFR: number
    itens: IResponseResultGroupsItems[]
  }
}

export interface IResponseResultGroupsItems {
  bloqPagto: string
  cdContratoCobr: string
  descricao: string
  folhaRegServ: string
  formPagto: string
  idContratoCobr: number
  txDocumento: string
  tpDoc: string
  vencimento: Date | string
  vlLiquido: number
}
